import {
  Box,
  Typography,
  useTheme,
  IconButton,
  Grid,
  Button,
  useMediaQuery,
} from "@mui/material";
import React, { useState } from "react";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import Grid2 from "@mui/material/Grid2";
import { useDispatch, useSelector } from "react-redux";
import ExpandLessTwoToneIcon from "@mui/icons-material/ExpandLessTwoTone";
import ExpandMoreTwoToneIcon from "@mui/icons-material/ExpandMoreTwoTone";
import { format_Number } from "../../utils/utils";
import CardSection from "./CardSection";

const UpsaleProduct = ({
  errors, isLoading, steps, activeStep, handleBack, handleNextFunc,
  price, languageId, setQuantities, setSelectedExtraProduct, extraProductData,
  quantities, totalCount, languageWords, reservType, selectedDate,
  adult, child, kid, baby, toddler, selectedExtraProduct, time,
  transactionDetails, selectedCombination, transactionPrice, excludingVat,
  totalVat, totalIncludingVAT, totalCostYourBooking, combinationUpsale, total_product_price,
}) => {
  const IMG_URL = process.env.REACT_APP_API_LOCAL_IMG_URL;
  const { css } = useSelector((store) => store?.widgetSettings);
  const extraProductCss = css?.find(
    (item) => item?.cssTabFieldsGroupName === "Extra products"
  )?.fields;
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [isShowMore, setIsShowMore] = useState(false);
  const dispatch = useDispatch();
  const { widgetConfig } = useSelector((store) => store?.widgetSettings);
  const [isImageValid, setIsImageValid] = useState(true);

  const productsToDisplay =
    extraProductData?.length > 0
      ? isShowMore ? extraProductData : extraProductData?.slice(0, 4)
      : [];

  const handleProductSelect = (item) => {
    const isSelected = selectedExtraProduct.some((p) => p.idproduct === item.idproduct);
    if (isSelected) {
      dispatch(setSelectedExtraProduct(selectedExtraProduct.filter((p) => p.idproduct !== item.idproduct)));
      dispatch(setQuantities({ ...quantities, [item.idproduct]: 1 }));
    } else {
      const qty = quantities[item.idproduct] || 1;
      dispatch(setSelectedExtraProduct([...selectedExtraProduct, { ...item, quantity: qty }]));
      dispatch(setQuantities({ ...quantities, [item.idproduct]: qty }));
    }
  };

  const handleQuantityChange = (e, item, increment) => {
    e.stopPropagation();
    const currentQuantity = quantities[item.idproduct] || 1;
    if (!increment && currentQuantity <= 1) {
      dispatch(setQuantities({ ...quantities, [item.idproduct]: 1 }));
      dispatch(setSelectedExtraProduct(selectedExtraProduct.filter((p) => p.idproduct !== item.idproduct)));
      return;
    }
    const newQuantity = Math.max(currentQuantity + (increment ? 1 : -1), 1);
    dispatch(setQuantities({ ...quantities, [item.idproduct]: newQuantity }));
    const alreadySelected = selectedExtraProduct.some((p) => p.idproduct === item.idproduct);
    if (alreadySelected) {
      dispatch(setSelectedExtraProduct(
        selectedExtraProduct.map((p) =>
          p.idproduct === item.idproduct ? { ...p, quantity: newQuantity } : p
        )
      ));
    } else {
      dispatch(setSelectedExtraProduct([...selectedExtraProduct, { ...item, quantity: newQuantity }]));
    }
  };

  return (
    <Box>
      <Grid2 container spacing={2}>
        <Grid2 size={{ md: 9, sm: 12, xs: 12 }}>
          {productsToDisplay?.map((item, index) => (
            <Box
              key={index}
              onClick={() => handleProductSelect(item)}
              sx={{
                border: "1px solid #EBEBEB",
                p: { xs: 1, sm: 1.5, md: 2 },      
                borderRadius: "10px",
                backgroundColor: selectedExtraProduct?.some(
                  (product) => product.idproduct === item.idproduct
                ) ? extraProductCss?.upsaleHighllightBgClr : extraProductCss?.upsaleCardBgClr,
                mb: { xs: 1, sm: 2 },                
                boxShadow: "rgba(0, 0, 0, 0.1) 2px 2px 8px",
                width: "100%",
                cursor: "pointer",
                transition: "all 0.3s ease",
                "&:hover": { boxShadow: "rgba(0, 0, 0, 0.2) 4px 4px 12px" },
              }}
            >
              <Grid container spacing={1} alignItems="center">
                {item?.image && isImageValid && (
                  <Grid item xs={12} sm={4} md={2}>
                    <Box sx={{
                      width: "100%", height: "100%", display: "flex",
                      justifyContent: "center", alignItems: "center",
                      borderRadius: "8px", overflow: "hidden",
                    }}>
                      <img
                        src={`${IMG_URL}upload/product${item?.image.replace(/\\/g, "/")}`}
                        alt={item?.languages[0]?.data}
                        style={{ width: "100%", height: "100%", objectFit: "cover" }}
                        onLoad={() => setIsImageValid(true)}
                        onError={() => setIsImageValid(false)}
                      />
                    </Box>
                  </Grid>
                )}

                <Grid item xs={12} sm={8} md={item?.image && isImageValid ? 10 : 12}>
                  <Box sx={{ width: "100%" }}>

                    {/* ── Title + Add Button ── */}
                    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                      <Typography sx={{
                        fontSize: { xs: "13px", sm: "14px", md: "1rem" },
                        fontWeight: "bold",
                        color: selectedExtraProduct?.some((product) => product.idproduct === item.idproduct)
                          ? extraProductCss?.upsaleHighlightTxtrCLr
                          : extraProductCss?.upsaleProductHeadingClr,
                        flex: 1,
                        mr: 1,
                      }}>
                        {item?.languages[0]?.data || item?.productName}
                      </Typography>

                      <Button
                        variant="outlined"
                        onClick={(e) => { e.stopPropagation(); handleProductSelect(item); }}
                        sx={{
                          position: "relative",
                          borderRadius: "10px",
                          padding: { xs: "4px 8px", sm: "6px 12px", md: "8px 16px" }, 
                          minWidth: { xs: "70px", sm: "90px", md: "120px" },          
                          borderColor: "#dcdcdc",
                          textTransform: "none",
                          display: "flex",
                          flexDirection: "column",
                          lineHeight: 1.2,
                          flexShrink: 0,
                          "&:hover": { borderColor: "#bdbdbd" },
                        }}
                      >
                        <Typography sx={{
                          fontSize: { xs: "11px", sm: "12px", md: "14px" },
                          fontWeight: 500,
                          color: selectedExtraProduct?.some((product) => product.idproduct === item.idproduct)
                            ? extraProductCss?.ProductItemAddButtonTextColorActive : "grey",
                        }}>
                          {languageWords?.Add}
                        </Typography>

                        {item?.price > 0 && (
                          <Typography sx={{
                            fontSize: { xs: "11px", sm: "12px", md: "13px" },
                            color: selectedExtraProduct?.some((product) => product.idproduct === item.idproduct)
                              ? extraProductCss?.ProductItemAddButtonTextColorActive
                              : extraProductCss?.ProductItemPriceColor,
                            fontWeight: 600,
                          }}>
                            €{format_Number(parseFloat(item?.price).toFixed(2))}
                          </Typography>
                        )}

                        {selectedExtraProduct?.some((p) => p.idproduct === item.idproduct) && (
                          <DeleteOutlineIcon
                            sx={{ position: "absolute", bottom: 4, right: 4, fontSize: { xs: 14, sm: 16, md: 18 }, color: "#fff", cursor: "pointer" }}
                            onClick={(e) => { e.stopPropagation(); handleProductSelect(item); }}
                          />
                        )}
                      </Button>
                    </Box>

                    {/* ── Description ── */}
                    {(item?.languages?.[1]?.data || item?.productinformation) && (
                      <Typography sx={{
                        color: selectedExtraProduct?.some((product) => product.idproduct === item.idproduct)
                          ? extraProductCss?.upsaleHighlightTxtrCLr : extraProductCss?.upsaleProductInfoClr,
                        fontSize: { xs: "12px", sm: "13px", md: "14px" },
                        mt: 0.5, mb: 1,
                      }}>
                        {item?.languages?.[1]?.data || item?.productinformation}
                      </Typography>
                    )}

                    {/* ── Quantity Stepper ── */}
                    <Box sx={{ display: "flex", justifyContent: "flex-end", alignItems: "center" }}>
                      <Box sx={{
                        display: "flex", alignItems: "center", gap: { xs: "4px", sm: "8px" },
                        px: { xs: 0.5, sm: 1 }, py: 0.5,
                        borderRadius: "999px",
                        backgroundColor: selectedExtraProduct?.some((product) => product.idproduct === item.idproduct)
                          ? "rgba(255,255,255,0.15)" : "rgba(0,0,0,0.04)",
                        backdropFilter: "blur(6px)",
                      }}>
                        <span onClick={(e) => e.stopPropagation()}>
                          <Button
                            onClick={(e) => handleQuantityChange(e, item, false)}
                            disableRipple
                            sx={{
                              minWidth: { xs: 28, sm: 32, md: 36 }, 
                              height: { xs: 28, sm: 32, md: 36 },
                              borderRadius: "50%",
                              fontSize: { xs: "16px", sm: "18px", md: "20px" },
                              fontWeight: 600,
                              color: selectedExtraProduct?.some((product) => product.idproduct === item.idproduct)
                                ? extraProductCss?.ProductItemAddButtonTextColorActive : "grey",
                            }}
                          >−</Button>
                        </span>

                        <Typography sx={{
                          minWidth: { xs: 20, sm: 24, md: 28 },
                          textAlign: "center",
                          fontSize: { xs: "12px", sm: "13px", md: "14px" },
                          fontWeight: 600,
                          color: selectedExtraProduct?.some((product) => product.idproduct === item.idproduct)
                            ? "#fff" : "#424242",
                          transition: "color 0.3s ease",
                        }}>
                          {quantities[item.idproduct] || 1}
                        </Typography>

                        <Button
                          onClick={(e) => handleQuantityChange(e, item, true)}
                          disableRipple
                          sx={{
                            minWidth: { xs: 28, sm: 32, md: 36 },
                            height: { xs: 28, sm: 32, md: 36 },
                            borderRadius: "50%",
                            fontSize: { xs: "16px", sm: "18px", md: "20px" },
                            fontWeight: 600,
                            color: selectedExtraProduct?.some((product) => product.idproduct === item.idproduct)
                              ? extraProductCss?.ProductItemAddButtonTextColorActive : "grey",
                            backgroundColor: "transparent",
                            transition: "all 0.25s ease",
                            "&:hover": { backgroundColor: "rgba(0,0,0,0.08)", transform: "scale(1.05)" },
                            "&:active": { transform: "scale(0.95)" },
                          }}
                        >+</Button>
                      </Box>
                    </Box>

                  </Box>
                </Grid>
              </Grid>
            </Box>
          ))}

          {extraProductData?.data?.length > 4 && (
            <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
              <IconButton
                sx={{
                  backgroundColor: theme?.product?.addBtnBg, fontSize: "14px",
                  color: theme?.product?.addBtnTextColor,
                  "&:hover": { backgroundColor: theme?.product?.addBtnBgHover, color: theme?.product?.addBtnTextHover },
                }}
                onClick={() => setIsShowMore(!isShowMore)}
              >
                {!isShowMore ? <ExpandMoreTwoToneIcon /> : <ExpandLessTwoToneIcon />}
              </IconButton>
            </Box>
          )}
        </Grid2>

        <Grid2 size={{ md: 3, sm: 12, xs: 12 }}>
          <CardSection
            price={price} errors={errors} isLoading={isLoading} steps={steps}
            activeStep={activeStep} handleBack={handleBack} handleNextFunc={handleNextFunc}
            languageId={languageId} totalCount={totalCount} languageWords={languageWords}
            reservType={reservType} selectedDate={selectedDate} adult={adult} child={child}
            kid={kid} baby={baby} toddler={toddler} selectedExtraProduct={selectedExtraProduct}
            time={time} transactionDetails={transactionDetails} selectedCombination={selectedCombination}
            transactionPrice={transactionPrice} excludingVat={excludingVat} totalVat={totalVat}
            totalIncludingVAT={totalIncludingVAT} totalCostYourBooking={totalCostYourBooking}
            combinationUpsale={combinationUpsale} total_product_price={total_product_price}
          />
        </Grid2>
      </Grid2>
    </Box>
  );
};

export default UpsaleProduct;